export const TEMPLATE_LINK = "https://github.com/TsAnastasia/template";
// TODO: add link to lab site
export const LAB_LINK = "https://gitlab.com/itmo_nccr";
